import { createContext, type ReactNode, useContext } from "react";

const OverlayVisibilityContext = createContext(true);

/** Hidden retained windows/tabs also suspend their portals, without disposing drafts. */
export function OverlayVisibilityProvider({
  visible,
  children,
}: {
  visible: boolean;
  children: ReactNode;
}) {
  const parentVisible = useContext(OverlayVisibilityContext);
  return (
    <OverlayVisibilityContext.Provider value={parentVisible && visible}>
      {children}
    </OverlayVisibilityContext.Provider>
  );
}

export function useOverlayVisibility() {
  return useContext(OverlayVisibilityContext);
}
